// @secure

export enum WidgetStyle {
  OnlyTimePeriod,
  OnlyFilters,
  All,
  AllWithCriteria,
  None
}
